export const en = {
  paymentfailed: {
    title: "Account has been downgraded",
    description: "Update Payment Information",
    body1:
      "Your credit card information needs to be updated due to an unsuccessful charge to your card.<br>Current customers have downgraded to a free plan.",
    do: "Update Payment Information",
    "need-login": "Please log in and open this page again.",
  },
  click: "Click",
  team: {
    description:
      "Create teams and combine billing and account management into one",
    manual: "Manually enter your email address",
    manual_placeholder: "If more than one, please start a new line.",
    csv: "Or upload as CSV",
    csv_format: "CSV Format",
    can_not_invite: "Cannot be invited due to team affiliation",
    invite: "Invitation to Team",
    invite_date: "Invite date",
    invite_count: "Number of people to invite",
    invite_done: "Invitation completed 🎉",
    confirm: "Confirm",
    confirm_text: "Send an invitation to the following users 💁",
    need_subscription: "A Premium Business Plan is required to create a team",
    you_are_member: "You are a team member of the following account",
    member: "member",
    status: {
      title: "status",
      0: "pending",
      1: "using",
    },
    member_count: "members",
    name: "name",
    delete: {
      message:
        "Deleting a member will delete files, groups, and accounts uploaded by the member",
      error: {
        invalid_email: "Email address is formatted incorrectly",
        choose: "Please select a file",
      },
    },
  },
  free_user: "free user",
  premium_user: "premium user",
  business_user: "business user",
  developer_user: "developer user",
  onetime_user: "One-time Plan",
  cancel: "Cancel",
  email: "EMAIL",
  email_file: {
    need_login: "You must be logged in to send email.",
    modal: {
      title: "Please enter the e-mail address.",
      description: "We'll send an email on your behalf.",
      submit: "Submit",
    },
  },
  about: {
    dashboard: {
      title: "File Management",
      description:
        "You can manage your files in various ways on the dashboard.",
      list: {
        title: "Checking uploaded files",
        description:
          'The dashboard allows you to view files that have been uploaded in the past. This screen is also used to obtain URLs for direct links and "shared URLs" for sharing files. If you have added a file to a group, deleted a file, or encrypted a file, you can confirm the password here.',
      },
      group: {
        title: "Tagging with group management",
        description:
          "Files uploaded to a group can be added. You can also search for files by group and publish files added to a group to the outside world by making the group public. You can also delete files added to a group by deleting the group.",
      },
    },
    security: {
      title: "Security Initiatives",
      description:
        "Learn about our security initiatives to protect your information.",
      "file-check": {
        title: "Real-Time virus check",
        description:
          "HStorage performs real-time virus checks on all uploaded files. In the unlikely event that a virus is detected, a warning will be issued at the time of download.\n",
      },
      information: {
        title: "Encrypted personal information",
        description:
          "Your email address and credit card information are not stored on our servers. <a href='https://auth0.com' target='_blank' rel='noreferrer'>Auth0</a> manages users, and <a href='https://stripe.com' target='_blank' rel='noreferrer'>Stripe</a> manages credit card information. Security matters are accomplished through our policy of using security-focused services.",
      },
      encrypt: {
        title: "Encrypt the file itself",
        description:
          "This encryption system is available by enabling it at the time of upload. Unlike other online storage uploaders, the file itself is encrypted so that it cannot be recovered in case the file is leaked. You can also share files by telling the other party your password.",
      },
      backend: {
        title: "Transparency",
        description:
          "HStorage provides you with a configuration diagram of how your information is processed and managed.",
      },
    },
  },
  asct: {
    about: {
      title: "Time of provision of services",
      value: "You can start using it immediately after registration.",
    },
    address: {
      title: "Adress",
      value: "〒105-0013 Tokyo, Minato-ku, Hamamatsucho 2-2-15",
    },
    support_email: {
      title: "Support Email Address",
      value: "support@hstorage.io",
    },
    support_phone: {
      title: "Support Phone Number",
      value: "070-2667-2002",
    },
    support_time: {
      title: "Support Hours",
      value: "10:00-19:00",
    },
    description:
      "Based on Article 11 of the 'Act on Specified Commercial Transactions' (advertisement regarding mail order sales), the following information is disclosed",
    owner_company: {
      title: "Sales Company",
      value: "HCloud Ltd",
    },
    owner_person: {
      title: "Sales Representative",
      value: "Takuya Hasegawa",
    },
    payment_method: {
      title: "Payment Methods",
      value: "Credit card, Bank transfer, Convenience store payment",
    },
    payment_period: {
      title: "Payment Timing",
      value: "<ul><li>Credit card payment: Processed immediately upon order.</li><li>Convenience store payment: Please pay within 3 days of order.</li><li>Bank transfer: Please pay within 3 days of order.</li></ul>",
    },
    offer: {
      title: "Service Provision Period",
      value: "Available immediately after registration",
    },
    fee: {
      title: "Additional Fees",
      value: "No shipping fees due to the nature of the product/service",
    },
    cancel: {
      title: "About Cancellation",
      value: "Cancellation is possible from the bottom of the settings page in the dashboard after login",
    },
    price: {
      title: "Price",
      value: "Depends on the plan",
    },
    title: "Specified Commercial Transactions Act",
  },
  close: "Close",
  contact: {
    title: "Contact",
  },
  continue: "Continue",
  copy: "Copy",
  dashboard: {
    title: "Dashboard",
    api: {
      description: "Click here for the API documentation.",
      title: "API Key",
    },
    api_only: "API User Only",
    create: "Create",
    group: {
      admin: {
        changed: "Public status has been changed",
        copy: "Copy",
        description: "You can add files to a group and manage them.",
        label: {
          count: "File count",
          name: "Name",
          view_status: "Open group",
          upload_status: "Allow uploads from others",
          view_url: "Group URL",
          delete: "Delete",
        },
        preview: "Preview",
        title: "Manage Group",
      },
      upload_info:
        "<span class='has-text-primary'>{n}</span> will be<br class=\"is-hidden-desktop\">uploaded and shared",
      already: "It already exists.",
      created: "You have created a group",
      delete: {
        message: "Deleting a group deletes all files in the group.",
      },
      none: "Not Set",
    },
    onlyPremium: "Premium only",
    password: {
      description:
        "Click here for information about passwords and encryption keys.",
      title: "Password・Cryptographic key",
    },
    placeholder: {
      1: "File Name, Group Name",
    },
    premium_only: "Premium Only",
    usage: {
      title: "Usage",
      count: "Total file count",
      total_size: "Total file size",
    },
    search: "Search",
    setting: {
      title: "Setting",
      payment: "Change payment, receipt",
    },
    tag: {
      none: "None",
    },
  },
  delete: {
    delete: "Delete",
    already_deleted: "Already Deleted",
    deleted: "Successfully deleted",
    error: {
      not_allowed:
        "You do not have permission to delete this file, or it has already been deleted",
    },
  },
  delete_account: {
    execute: "Withdraw",
    sub_title: "If you withdrawal, all data will be deleted",
    title: "Withdrawal",
  },
  dropzone: {
    upload: "Drop your files here or click to upload",
    setting: {
      password: {
        title: "Set a password?",
        description:
          "You can set a password to protect your files. Direct links are not available.",
      },
    },
    limit: {
      continue: "Upload",
    },
    error: {
      max_files_20_description:
        "Free uploads are limited to 20 🙏 Premium plans allow unlimited simultaneous uploads!",
      max_files_20_title: "Need Premium 💁",
    },
    init: "Connecting to server",
  },
  error: {
    error: "An error has occurred. Please wait for resolution.",
    title: "Error",
    connection: {
      title: "Could not connect to server",
      message:
        "Please disable anti-virus software or add these domains to whitelist. <b>hstorage.io</b> and <b>api.hstorage.io</b>",
    },
    please_set_email:
      "Failed to get email address.<br>Make sure you have registered your email address with the SNS.",
  },
  faq: {
    description: "If you cannot resolve your issue with the FAQ, please <a href='/contact'>contact us</a>",
    1: {
      title: "Retention period",
      value:
        "Free users: 20MB or less, Premium users: 5GB or less, unlimited storage. Above that, the file will be deleted in 2 weeks.",
    },
    2: {
      title: "Can my files be viewed or censored?",
      value:
        "We do not have access to your files. Only our representative has access to the file server. We may disclose your file if we are compelled by law to do so.",
    },
    4: {
      title: "Problem files",
      value: 'If you find a problematic file, please contact us via "chat"',
    },
    5: {
      title: "Disclosure of personal information",
      value:
        'Disclosure of IP addresses please check <a href="https://hstorage.io/blog/usage/2022/08/07/information-disclosure.html" target="_blank" rel="noreferrer">this</a> document.',
    },
    6: {
      title: "Configuration",
    },
    8: {
      title: "Security",
      value: {
        1: "User information is not maintained in-house, but is managed by Auth0, which has a high level of security.",
        2: "We do not manage our own credit card information, but use Stripe. We also use rate limiting to protect against dictionary attacks on files.",
      },
    },
    9: {
      title: "Change e-mail address",
      value: "Please contact us",
    },
    10: {
      title: "Upload limitation",
      value:
        "Free users are limited to a total of 20MB per upload. Premium users are limited to 5GB per upload, with no limit on simultaneous uploads. You can upload files larger than 20MB or 5GB, but the storage period will be limited to 2 weeks.",
    },
    11: {
      title: "Delete Account",
      value: 'Please login and click the "Withdrawal" in the menu.',
    },
    12: {
      title: "Free Trial",
      value:
        "You can try the premium features for free for two weeks. No charge if you cancel during the period; the second free trial is not applicable.",
    },
    13: {
      title: "Contact",
      value: {
        1: "Please contact us from the lower right corner of the screen.",
      },
    },
    14: {
      title: "Difference between a shared link and a direct link",
      value:
        "A shared link is a link to share a file. A direct link is used to embed a file",
    },
    15: {
      title: "Delete Date/Time",
      value:
        "You can automatically delete files by setting the date and time to be deleted. If not set, the file will be automatically deleted with or without a premium user. <br>The file may be deleted up to 30 minutes beyond the set date and time.",
    },
    17: {
      title: "Can't open direct links or get redirected",
      value:
        "Files uploaded by free users will be redirected to the shared URL under certain conditions.",
    },
    18: {
      title: "Account is restricted",
      value:
        "You may have multiple free accounts. please contact us if you would like to consolidate your files into one account. Premium and Business users are not affected by this.",
    },
    category: ["File", "Delete request", "Security", "Account"],
    title: "Q&A",
  },
  footer: {
    description: "Easy and free with your SNS account",
    logo_alt: "HStorage Cloud Storage Logo",
    twitter_label: "Twitter Profile",
    community_label: "User Community Site",
    company_name: "HCloud Ltd",
    official_blog: "Official Blog",
    system_status: "System Status",
    community_forum_label: "User Community Site Forum",
    community_link: "Community",
    advertisement: "About Advertising",
    latest_news_label: "Latest News",
    latest_news: "Latest News",
  },
  list: {
    buttons: {
      direct: "Direct link URL copy",
      download: "Download",
      share: "Copy shared URL",
    },
    info: {
      count: "Times displayed：",
      date: "Date：",
      size: "Size：",
    },
    label: {
      group: "Group",
      file_type_filter: "Filter by File Type",
      sort_by: "Sort By",
    },
    filter: {
      all: "All",
      image: "Images",
      video: "Videos",
      pdf: "PDF",
      word: "Word",
      excel: "Excel",
      powerpoint: "PowerPoint",
      csv: "CSV",
      archive: "Archives",
    },
    sort: {
      default: "Default",
      file_size_desc: "Size Large→Small",
      file_size_asc: "Size Small→Large",
      delete_date_desc: "Delete Date New→Old",
      delete_date_asc: "Delete Date Old→New",
      created_at_desc: "Created New→Old",
      created_at_asc: "Created Old→New",
    },
    delete_scheduled: "Delete scheduled:",
    video: {
      done: {
        title: "Converted",
        value:
          "The video file has been converted to make it easier to watch. The original data is still available for download.",
      },
      in_progress: {
        title: "Converting",
        value:
          "The video file is being converted to make it easier to watch. The original data is still available for download.",
      },
      in_queue: {
        title: "Converting",
        value:
          "The video file is being converted to make it easier to watch. The original data is still available for download.",
      },
    },
    group_modal: {
      title: "Add to Group",
      description: "Select a group to add the selected {count} file(s) to.",
      placeholder: "Select a group",
      add_button: "Add to Group",
      cancel_button: "Cancel",
      add_to_group_button: "Add selected {count} file(s) to group",
      toast: {
        no_files_selected: "Please select files to add to group.",
        no_groups: "No groups have been created. Please create a group first.",
        no_group_selected: "Please select a group.",
        adding: "Adding selected files to group...",
        success: "Added {count} file(s) to group \"{groupName}\".",
        partial_success: "Added {successCount} file(s) to group. Failed to add {failedCount} file(s).",
        all_failed: "Failed to add files to group.",
        error: "An error occurred while adding to group."
      }
    },
    buttons: {
      download_selected: "Download selected {count} file(s)",
      delete_selected: "Delete selected {count} file(s)",
      select_all: "Select all files",
      deselect_all: "Deselect all",
      toggle_grid: "Switch to grid view",
      toggle_card: "Switch to card view",
      show_filter: "Show filter",
      hide_filter: "Hide filter",
      close: "Close",
      aria_copy: "Copy button",
      download: "Download",
      add_to_group: "Add to group",
      lock: "Lock",
      unlock: "Unlock",
      delete: "Delete"
    },
    selected_files_text: "Selected {count} item(s) to",
    view_mode: {
      grid: "grid",
      card: "card"
    },
    fields: {
      encrypt_key: "Encryption Key",
      password: "Password"
    },
    hint: {
      long_press_title: "<strong>Long press</strong> items<br>to select multiple",
      long_press_desktop: "Hint: Long press items to select multiple",
      selection_mode: "Entered selection mode"
    },
    fields: {
      encrypt_key: "Encryption Key",
      password: "Password"
    },
    hint: {
      long_press_title: "<strong>Long press</strong> items<br>to select multiple",
      long_press_desktop: "Hint: Long press items to select multiple",
      selection_mode: "Entered selection mode"
    },
    toast: {
      group_not_selected: "No group selected",
      group_added: "Added to group \"{groupName}\"",
      group_removed: "Removed from group",
      group_not_found: "Selected group not found",
      download_no_files: "Please select files to download.",
      download_generating_zip: "Generating ZIP file...",
      download_skip_encrypted: "Cannot include encrypted or password-protected file in ZIP: {fileName}",
      download_starting: "Starting download of selected files...",
      download_processing: "Downloading {fileName}...",
      download_creating_zip: "Creating ZIP file...",
      download_partial_failed: "The following files could not be included in the ZIP due to password/encryption: {files}",
      download_all_failed: "No files could be included in the ZIP.",
      download_empty_zip: "ZIP file is empty.",
      download_zip_error: "Failed to generate ZIP file: {error}",
      download_completed: "Downloaded as ZIP.",
      delete_no_files: "Please select files to delete.",
      delete_processing: "Deleting files...",
      delete_success: "Deleted {count} file(s).",
      delete_partial_success: "Deleted {successCount} file(s). Failed to delete {failedCount} file(s).",
      delete_all_failed: "Failed to delete files.",
      delete_error: "An error occurred during deletion.",
      file_locked: "File locked",
      file_unlocked: "File unlocked",
      lock_failed: "Failed to change file lock status",
      no_permission: "You do not have permission to operate this file",
      file_not_found: "File not found",
      filter_changed: "Filter changed to \"{filterLabel}\"",
      sort_changed: "Sort changed to \"{sortLabel}\"",
      view_mode_changed: "Switched to {modeLabel} view",
      filter_shown: "Filter shown",
      filter_hidden: "Filter hidden",
      lock_no_files: "Please select files to lock.",
      locking_files: "Locking files...",
      unlocking_files: "Unlocking files...",
      files_locked: "Locked {count} file(s).",
      files_unlocked: "Unlocked {count} file(s).",
      lock_partial_success: "Changed lock status for {successCount} file(s). Failed for {failedCount} file(s).",
      lock_all_failed: "Failed to change file lock status.",
      lock_error: "An error occurred during lock operation."
    },
    dialog: {
      delete_title: "Confirm File Deletion",
      delete_message: "Are you sure you want to delete the selected {count} file(s)?<br><strong>This action cannot be undone.</strong>",
      delete_confirm: "Delete",
      lock_title: "Confirm File Lock",
      unlock_title: "Confirm File Unlock",
      lock_message: "Change the status of {count} selected file(s).",
      lock_confirm: "Lock",
      unlock_confirm: "Unlock",
      locked_delete_title: "Cannot Delete",
      locked_delete_message: "{count} of {total} selected file(s) are locked and cannot be deleted.<br>Please unlock the files first before deleting them.",
      locked_files_info: "{count} of {total} selected file(s) are locked",
      unlock_instruction: "To delete the files, please unlock them first.",
      close: "Close",
      cancel: "Cancel"
    },
  },
  login: "Login",
  logout: "Logout",
  navbar: {
    reload: "Update",
    top: "Top",
  },
  only_premium_long:
    "This feature is only available in Premium. Please try 14 days trial💁",
  privacy: {
    1: "Compliance with laws and regulations regarding personal information protection",
    2: "About the use of cookies",
    3: "Terms of use and disclaimer",
    4: "Disclaimer",
    5: "Agreement to terms of use",
    6: "Operating company",
    "1_1":
      "We comply with the Personal Information Protection Act, the provisions of the Telecommunications Business Act regarding the secrecy of communications, other related laws and regulations, and guidelines for personal information protection in the telecommunications business regarding the handling and use of users' personal information.",
    "2_1":
      "HStorage uses cookies for some content on the site in order to provide better services to customers.",
    "2_2":
      "The information obtained at that time does not include information that can identify individual customers.",
    "2_3":
      "We also provide information obtained through cookies as reference information to the third-party companies listed below.",
    "2_4":
      "The provided information is mainly used for optimizing ad display on the site.",
    "2_5":
      "For other information about the use of cookies and opt-out (the right to refuse the use of cookies), please contact us through the inquiry form if you would like detailed information.",
    "3_1": "Prohibition of file transfer that violates copyright law",
    "3_2":
      "All uploading and downloading of files that violate copyright law is prohibited. All uploading and downloading of files that violate public order and morals is also prohibited. If files that fall under these categories are discovered, the management side may delete the files at its own discretion without notice.",
    "4_1":
      "Even if file transfer failure or file loss due to server failure occurs, this site and the operating company shall not be liable for any damages. This site and the operating company shall also not be liable for any use behavior on external sites such as advertisements.",
    "4_2":
      "For any other damages, this site and the operating company shall not be liable.",
    "5_1":
      "By using the service, you are deemed to have agreed to these terms of use and disclaimer. This site and the operating company may revise all terms without prior notice.",
    title: "Privacy Policy",
  },
  show: {
    security: {
      button: "Concerned about HStorage's security?",
      check: {
        title: "HStorage's virus check",
        passed: "No virus found.",
        infected: "A virus has been discovered.",
      },
    },
    access_count: "number of accesses: ",
    button: {
      direct: "Copy the direct link URL",
      download: "Download",
      download_encrypt: "Enter the password to download",
      share: "Copy the shared URL",
    },
    deleted: "This file has been deleted.",
    deleted_message: {
      line1: "The file has been deleted by the user.",
      line2:
        "HStorage does not investigate uploaded files or automatically delete files with high access counts.",
    },
    ad: {
      message:
        "Would you like to place an ad on this page starting from 30,000 yen per month?",
    },
    adblock: {
      message:
        "Please disable ad blocker to enable buttons.<br>This file was uploaded with a free account so ads need to be displayed.",
    },
    qr: {
      message: "\\Scan QR code to download file/",
    },
    validation: {
      invalid_password: "The password is incorrect",
      invalid_hashed: "The encryption key is incorrect",
    },
    video_error: {
      title: "Please download",
      line1: "Playback failed in your environment.",
      line2: "Please download the file and play it on your device.",
    },
    video: {
      converting: "Converting (original available)",
      converted: "Converted (original available)",
    },
    description: {
      1: "If you want to share this file with others,",
      2: "If you want to share this file, please share the URL of this page",
    },
    download_password: "Please enter your password to download",
    encrypted: "This file is encrypted.",
    group: {
      error: {
        not_found: "This group does not exist or has already been deleted.",
        not_public_view:
          "This group is not public.<br>Please contact the owner to change the public status.",
        not_public_upload:
          "Uploading to this group is not allowed.<br>Please contact the owner to change permissions.",
      },
      title: "Group Details",
    },
    info: {
      count: "Times displayed：",
      date: "Date：",
      size: "Size：",
    },
    password: {
      need: "Enter a password",
    },
    play: "Play",
    title: "File Details",
    snackbar: {
      hstorage_managed: "This file is managed by HStorage🎉",
    },
  },
  sidebar: {
    action: "Action",
    menu: "menu",
  },
  signup: "Sign In",
  signup_short: "Sign In",
  signup_button: "Sign Up<span class='has-text-white-ter'>—Free</span>",
  subscription: {
    already: "Under contract",
    api: {
      1: "Providing APIs",
      2: "Uploading restrictions are based on whether or not you have a premium plan.",
      get: "Get the API",
      price: "980 yen",
      title: "For Developers",
    },
    free: {
      1: "Files {n}MB or less are permanently stored",
      4: "Unlimited direct links",
      5: "Upload up to {n} files per month",
      6: "Up to 1 group management",
      7: "Store up to {n}GB total per account",
      8: "File encryption function",
      price: "0 yen",
      title: "Free",
    },
    logged_in: "Already loged in",
    login: "Login / Register",
    per_month: "/ Month",
    per_year: "/ Year",
    business: {
      1: "Hide ads all pages also share(download) page",
      2: "Highest priority support",
      3: "Same features as PREMIUM",
      4: "Up to 100GB per upload (without storage time limit)",
      5: "Account management",
      6: "User integration with LDAP / Active Directory",
    },
    premium: {
      1: "Up to 100GB per upload (with storage time limit)",
      2: "Up to 5GB (without storage time limit)",
      3: "Unlimited number of simultaneous uploads",
      4: "Unlimited number of uploads per month",
      5: "Unlimited number of file types.",
      7: "Expanded list functionality",
      8: "Unlimited group management functions",
      9: "Password and encryption functions",
      10: "Real-time processing of images",
      12: "Hide ads",
      13: "14-day free trial / Free if you cancel within the term",
      14: "No fees for up to a total of 4,999 files",
      15: "200 yen per 1,000 files for a pay-as-you-go fee for a total of 5,000 files or more",
      off: "20% off the monthly plan",
      title_yearly: "Premium yearly",
      trial: "Free trial",
    },
    title: "Plan",
    trial: "14-day free trial available for all plans",
    purchase: "Purchase",
    checkout: "Checkout",
    annotation: {
      1: "* Free trial is not available after the second time.",
      2: "* For Premium and Business plans, there is a usage fee of 1,500 yen per 500GB of storage.",
    },
  },
  success: {
    title: "Successfully upgraded a plan",
    api: "API keys can be viewed from the dashboard.",
  },
  tokutyou: {
    title: "Features",
  },
  top: {
    features: {
      title: "Features",
      description: "List of cloud storage features provided by HStorage",
    },
    update: {
      title: "Latest Information",
      description: "Latest information from Hstorage's official blog",
    },
    about_1:
      "HStorage is more advanced than other uploaders, and it's free and requires no registration.",
    about_2: "See the bottom of the page for more features.",
    about_3: "Click here to compare with other companies' services.",
    about_api: "API Document",
    about_encrypt: "About Encryption",
    about_feature: "About Function List",
    about_price: "Pricing and Features",
    about_server_load: "Current congestion level",
    check_email:
      "Please check your mailbox and complete your account registration. 👶",
    content: {
      free: "HStorage is an online storage service that requires no user registration and can be used immediately. HStorage is operated with the goal of simplicity and high functionality.",
      business:
        "Uploaded files can be opened with a direct link. You can use them on your website, etc., and there are no restrictions on their use. Images and videos will be saved in their original quality. There is no degradation.",
      network:
        "HStorage is connected to a fast network and can upload a 5GB file in less than a minute, and there is no limit to the number of simultaneous files you can upload at one time, so you don't have to open your site more than once.",
      plan: "The Premium plan is a flat rate of $5 per month, with a 14-day free trial available. It is greatly differentiated from the free plan in every detail, not to mention the relaxation of upload restrictions. Many of the features are based on feedback from our users.",
      world:
        "HStorage is an online storage service that is used by about 200,000 users per month.<br>In terms of the number of times a file is sent, it exceeds about 35 million times per month.<br>Why don't you use HStorage for secure and fast online storage service?",
      api: 'You can use the API to upload files. It can be used for a variety of purposes, including integration into applications and automation of uploads.<br>If you have any questions, please feel free to contact us using the "Contact" link at the bottom right of the page.',
      private_encrypt:
        "You can share files with specific people because no one will know about the uploaded files unless you make them public.<br>After you upload a file using HStorage, you can share it with others at the touch of a button, so you don't have to type every single sentence.<br>The encryption option encrypts the file and makes it accessible only to those who know the password, further increasing security.",
      personal_information:
        "Your information is managed by our next-generation authentication infrastructure, <a href='https://auth0.com' target='_blank' rel='noreferrer'>Auth0</a>, and your payment information, including credit card information, is managed by <a href='https://stripe. com' target='_blank' rel='noreferrer'>Stripe</a>. All information regarding your personal information will not be stored on our servers in any way.",
      cyber_attack:
        "All accesses have security measures in place to protect against brute force and rate limit attacks. All files are security-checked, and of course all access is encrypted with HTTPS connections.",
      clamav:
        "HStorage's security scans all files. <br><br><a href='https://github.com/Cisco-Talos/clamav' rel='noreferrer'>ClamAV</a> is used to inspect uploaded files in real time.",
    },
    delete_date: "Do you want to set a date and time for deletion?",
    delete_placeholder: "Click here to set the date and time for deletion.",
    deleted: "The file has been deleted. 💁",
    encrypt: {
      title: "Set Password・Encryption",
      value:
        "Setting a password increases the level of security. This feature will encrypt the file at the file level, and even if the file is lost, it will be safe because it is encrypted. This feature cannot be used with direct links. (Premium users only)",
    },
    error: {
      max_upload_size: "Files larger than 100GB cannot be uploaded.",
      already_deleted: "This file is already deleted",
      browser:
        "An error has been detected. If you are having problems, please review your browser's privacy (security) settings.",
      create_subscription: "Payment has failed. Please contact us.",
      customer_already:
        "You're already a premium user. Don't worry, no payment will be charged.",
      db_ping:
        "The service is temporarily stopped. This error has been notified to admin. You can check the recovery status on Twitter or at https://status.hcloud.ltd/status/hstorage",
      delete: "Failed to delete the file...😫 Please wait for a while",
      do_not_match_email:
        "The email address in the login information and the email address used for payment do not match. Please check again.",
      error:
        "Unknown error... 🙏 The server may be under maintenance. This issue already have been notified to the administrator.",
      ext: "This file cannot be uploaded by free users",
      "failed_to_request_pre-signed":
        "Failed to retrieve the signed URL.This error has been notified to admin. You can check the recovery status on Twitter or at https://status.hcloud.ltd/status/hstorage",
      file_name_not_found:
        "An unknown error has occurred.This error has been notified to admin. You can check the recovery status on Twitter or at https://status.hcloud.ltd/status/hstorage",
      get_upload_info: "The file has already been deleted.",
      getUserByEmailJWT: "Please try logging out and back in again.",
      getUserFromAuth0: "Please try logging out and back in again.",
      invalid_ext: "File extension is unknown. Please check.",
      isUserPremium:
        "Failed to identify whether the user is premium or not. This error has been notified to admin. You can check the recovery status on Twitter or at https://status.hcloud.ltd/status/hstorage",
      limit_exceeded_files:
        "You have reached your free user limit. Please consider becoming a subscribed user!",
      duplicated_user: "This account is banned. Please check Q&A",
      login_undefined:
        "Unable to log in. This may be caused by a browser extension with security features or the antivirus software in your OS.",
      no_login: "Please login and try again.",
      no_registered_token:
        "10 minutes has passed, please follow the steps again.",
      no_subscription:
        "We couldn't find your payment. If it seems to have been withdrawn, please contact us.",
      no_support:
        "That file is not supported... If you unlock premium, the restrictions go away! 😃 For more information, please see the FAQ",
      not_allowed: "You do not have permission to delete this file.",
      not_exists: "This file doesn't exist.",
      parseJWT:
        "Failed to retrieve user information... Please wait for a while",
      referer:
        "Your security software is not allowing you to send the necessary information. Please disable it temporarily.",
      restriction:
        "This file cannot be uploaded, please compress it to ZIP or something.",
      shorted:
        "Failed to retrieve the shortened URL.This error has been notified to admin. If you are in a hurry, try disabling the shortened URL. You can check the recovery status on Twitter or at https://status.hcloud.ltd/status/hstorage",
      unknown:
        "I'm getting an unknown error... 🙏 The server may be under maintenance. We have already notified the administrator of this error.",
      update_role:
        "Failed to update user information. The payment hasn't been made. Please contact us!",
      url_not_found: "Please enter the correct URL.",
    },
    faq: "Frequently Asked Questions",
    file_name: {
      period: "We do not allow pass the period in a file name",
      placeholder: "Do not pass the extension ie .jpg, .png",
      title: "Change file name",
      value:
        "You can rename it when you upload it.If you upload multiple files at the same time, it will look like 'File name-01'.",
    },
    send_email: "email has been sent. 👍",
    server_download: "Send from server",
    server_info_1:
      "The closer to 100%, the more it may affect the upload speed.",
    server_info_2: "HStorage uses a 1Gbps leased internet network.",
    server_load: "Server Congestion Level：",
    server_upload: "Upload to server",
    subtitle: "Large files will take longer, so please wait.",
    top: "Top",
    tokutyou: {
      title: "Service Features",
      description: "HStorage is visited by 200,000 people from around the world monthly and delivers files 35 million times per month.<br>We have never had a security incident and continue to provide reliability.",
    },
    verification_email: "Re-send email",
    verification_relogin:
      "Email address verification has been completed. Please re-login.",
    hero: {
      gradient: "Secure and Fast",
      normal: "Cloud Storage"
    },
    catch:
      "As a high-performance cloud storage service, HStorage provides reliability not only for individuals but also for businesses through free and secure file management and high-speed networks.",
    count: {
      1: "HStorage provide",
      2: "files.",
    },
    card: {
      tile: {
        security: {
          title: "Security",
          encrypt: {
            title: "Encrypt",
            desc: "Encrypt files and store them on our servers to reduce the risk of leakage<br>Advanced security not found in other services.",
          },
          virus: {
            title: "Real-Time Virus Check",
            desc: "All uploaded files are checked for viruses in real time.<br>If there is a problem, a warning will be displayed when downloading the relevant file.",
          },
        },
      },
      download: {
        download: "Download",
        count: "count limit",
        limit_date: "expiration date",
        password: "password",
        encrypt: "encrypt",
      },
      infinite: {
        storage: "Capacity ∞",
        count: "Files ∞",
      },
      processing: "Image Conversion",
      upload:
        "<span style='font-size:1.4em'>100</span> GB<br>Upload<span style='font-size:0.7em'>/count</span>",
      group: "Group Management",
      security: {
        title: "Strong<br class='is-mobile'>security",
        description:
          "HStorage performs virus checks on all files, and in the unlikely event that a virus is detected, a warning is issued at the time of download. In addition, the encryption function encrypts the file itself so that it cannot be recovered in case of leakage.",
        link: "Learn about our security",
      },
      free: {
        title: "Free",
        description:
          "Simply register as a member (free of charge) to use the service. No credit card information is required.",
      },
      direct: {
        title: "Direct Linkable",
        description:
          "Uploaded files can be opened with a direct link without degradation.",
      },
      network: {
        title: "Network",
        description:
          "A 5 GB file can be uploaded and downloaded in less than a minute.",
      },
      dashboard: {
        title: "Versatile<br class='is-mobile'>file management",
        description:
          "Uploaded files can be managed in a variety of ways through group management and collection features. It is also possible to set the number of times a file can be downloaded, set an expiration date, and automatically delete files. The group management and collection features are especially recommended.",
        link: "Learn about the Dashboard feature",
      },
    },
  },
  tos: {
    description: "HStorage (hereinafter referred to as 'this site') can only be used by those who agree to these terms of use.<br>These terms of use shall be effective when you access this site and use the service. If you do not agree, you cannot use it.",
    1: "HStorage (hereinafter referred to as 'this site') can only be used by those who agree to these terms of use.",
    2: "These terms of use shall be effective when you access this site and use the service. If you do not agree, you cannot use it.",
    3: "A. Summary of Terms of Use",
    4: "1. Comply with the Japanese Constitution and laws.",
    5: "2. Use at your own risk and the administrator assumes no responsibility.",
    6: "3. Use within the bounds of common sense.",
    7: "B. Regarding the use of services",
    8: "1. All of this site shall be used at your own risk, and the administrator assumes no responsibility for any disadvantages that may arise.",
    9: "2. The administrator shall have all rights arising from the use of this site. (Except for rights related to uploaded files.)",
    10: "3. Terms of use can be changed without notifying users. Changes will be applied at the same time as revision.",
    11: "4. Japanese law applies.",
    12: "5. All of this site may discontinue or suspend provision without notice.",
    13: "6. If you cannot understand the terms of use due to some trouble, do not use the service.",
    14: "C. Regarding uploaded files",
    15: "1. The user who uploaded the file is responsible for everything related to the uploaded file, and the administrator assumes no responsibility.",
    16: "2. Problems with third parties regarding uploaded files shall be resolved by the user who uploaded them.",
    17: "3. If there is any problem with uploaded files, the administrator can take action, but has no obligation to do so.",
    18: "D. Prohibited acts",
    19: "1. Acts that infringe on the rights of others, such as copyright.",
    20: "2. Acts that violate Japanese law.",
    21: "3. Acts that intentionally burden the server.",
    22: "4. Acts that may interfere with operations.",
    23: "5. Excessive continuous uploads.",
    24: "E. Information disclosure/action",
    25: "1. If the administrator determines that there is a violation of the terms of use of this site or that disclosure is necessary, the administrator may disclose and take action on user connection information, etc. Users cannot refuse this.",
    26: "2. When disclosure of information is required by laws and regulations, the administrator may disclose user connection information and other information to third parties. Users cannot refuse this.",
    27: "F. About the administrator/authority",
    28: "1. The administrator can take action and manage (delete, etc.) all of this site regardless of users, third parties, or requests. There is no obligation to do so.",
    29: "2. The administrator must not view or censor uploaded files except when required by law to disclose information.",
    30: "Updated: 2024 / 09 / 08",
    title: "Terms of Service",
  },
  unsubscription: {
    do: "Cancel my membership",
    title: "Unsubscribing",
    plan: "Plan Cancellation",
    premium: "Cancel Premium Plan",
    api: "Cancel API Plan",
    business: "Cancel Business Plan",
  },
  update: {
    title: "Update History",
  },
  uploaded: {
    title: "Uploaded",
    buttons: {
      direct: "Copy the direct link URL",
      processing: "Image Processing",
      share: "Copy the shared URL",
    },
    download_limit:
      "Specify the number of times it can be downloaded (displayed).",
    download_limit_description:
      "You can set the function to delete a shared page after it has been viewed X number of times. The default setting is unlimited.",
    group: {
      add: {
        description: "You can manage files in groups by adding them to a group",
        do: "Add",
        done: "Added to the group 💁",
        title: "Add to group",
      },
      create: {
        description:
          "You can also create a group here. Please add it to the group after creating it.",
        do: "Create",
        title: "Create group",
      },
      name: "Group name",
    },
    hankaku: "Half-angle numbers",
    only_premium: "Premium only",
    setting: "Settings",
    encryption: {
      title: "An encryption key is required to download and share files.",
      label: "Encryption key",
      label_aria: "About encryption key",
      label_describedby: "Encryption key content",
      copy_button_aria: "Button to copy encryption key",
      description:
        "The encryption key can also be confirmed from the Dashboard.",
      dashboard: "Dashboard",
    },
    password: {
      title: "A password is required to download and share this file.",
      label: "Password",
      label_aria: "About password",
      label_describedby: "Password content",
      copy_button_aria: "Button to copy password",
      description: "The password can also be confirmed from the Dashboard.",
      dashboard: "Dashboard",
    },
    copy_button: "Copy",
    thumbnail: {
      title: "It may take some time for thumbnail images to appear.",
      description:
        "The file has been uploaded successfully. Please check from the Dashboard.",
    },
    alt: {
      hstorage: "HStorage - Free direct linkable file sharing uploader",
    },
  },
  it_security_basic_policy: {
    title: "IT Security",
    content:
      "HCloud LLC (hereinafter, 'the Company') is committed to protecting information assets entrusted to us by customers and our own information assets from threats such as accidents, disasters, and crimes, and to respond to the trust of customers and society. We will work on information security throughout the company based on the following policies. <br><br>" +
      "1. Management's Responsibility<br>" +
      "The Company strives to improve and enhance information security in an organized and continuous manner under the leadership of management." +
      "<br><br>" +
      "2. Establishment of Internal Systems<br>" +
      "The Company establishes organizations for the maintenance and improvement of information security and defines information security measures as formal internal rules." +
      "<br><br>" +
      "3. Employee Initiatives<br>" +
      "Employees acquire the knowledge and technology necessary for information security and ensure their commitment to information security." +
      "<br><br>" +
      "4. Compliance with Legal and Contractual Requirements<br>" +
      "The Company complies with laws, regulations, standards, and contractual obligations related to information security, and meets customer expectations." +
      "<br><br>" +
      "5. Response to Violations and Incidents<br>" +
      "When violations of laws and regulations related to information security, contract violations, and incidents occur, the Company responds appropriately and strives to prevent recurrence.",
    footer: "Established: August 27, 2021<br>" + "HCloud LLC",
  },
  maintenance: {
    title: "Currently Under Maintenance👷",
    1: "Currently under maintenance. Maintenance will be completed in a few minutes.",
    2: "Maintenance status is announced on Twitter.",
  },
  rateLimited: {
    title: "Too Many Requests",
    description:
      "You have sent too many requests in a short period. Please wait a moment and try again.",
    waitMessage: "Please try again in about 30 seconds.",
    close: "Close",
  },
};
